import CloseIcon from '@mui/icons-material/CloseOutlined';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack, { StackProps } from '@mui/material/Stack';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useSidebar } from './CustomSidebarContext';

function SidebarHeader(props: StackProps) {
  const { children, onClick, ...rest } = props;
  const { isCollapsable, setCollapsed } = useSidebar();
  const theme = useTheme();
  const isSmallerThanMedium = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Stack
      direction='row'
      spacing={3}
      alignItems='center'
      justifyContent={isSmallerThanMedium ? 'space-between' : 'center'}
      p={3}
      pr={2}
      {...rest}
      onClick={onClick}
    >
      <Box
        sx={{
          ...(onClick ? { '&:hover': { opacity: 0.8, cursor: 'pointer' } } : {}),
        }}
      >
        {children}
      </Box>
      {isCollapsable && isSmallerThanMedium && (
        <IconButton size='small' onClick={() => setCollapsed((x) => !x)}>
          <CloseIcon />
        </IconButton>
      )}
    </Stack>
  );
}

export default SidebarHeader;
